import {
	ContextMenu,
	ContextMenuDeleteItem,
	ContextMenuItem,
	IJarvisUser,
	isSuccess,
	usePaginatedList,
} from "@dgs/core";
import { FC, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { createApplicationUserService } from "../shared/api/userService";

interface Props {
	user: IJarvisUser;
	handleOpen: (user: IJarvisUser) => void;
}

export const ApplicationUserListActions: FC<Props> = ({ user, handleOpen }) => {
	const { applicationId = "" } = useParams<"applicationId">();
	const service = useMemo(() => createApplicationUserService(applicationId), [applicationId]);
	const { reloadList } = usePaginatedList();
	const { t } = useTranslation();

	const detachUsers = useCallback(
		async (userIds: string[]) => {
			const response = await service.detachUsers(userIds);

			if (isSuccess(response)) {
				void reloadList();
			}
		},
		[service, reloadList],
	);

	return (
		<ContextMenu displayShortcutsAs="icon" size="small">
			<ContextMenuItem
				action={() => handleOpen(user)}
				label={t("Edit roles")}
				title={t("Edit roles")}
				icon="edit"
				shortcut="primary"
			/>
			<ContextMenuDeleteItem
				action={() => detachUsers([user.id])}
				label={t("Detach user")}
				heading={t("Detach user")}
				labels={{ close: t("Close"), confirm: t("Confirm") }}
				title={t("Detach user")}
			>
				{t(`Are you sure you want to remove the user {{name}} ({{email}}) from the application?`, {
					name: `${user.firstName} ${user.lastName}`,
					email: user.email,
				})}
			</ContextMenuDeleteItem>
		</ContextMenu>
	);
};
